module.exports = __webpack_public_path__ + "img/innerSix.3ecb995a.png";